import React, { useContext, useState } from 'react';
import { compose, difference, filter, flatten, map, path, pipe } from 'ramda';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { useSubscriptionOnDetailsUpdate } from '../withLeaderBoardDetails';
import { DetailsContext } from '../context';
import { fetchDetails, updateDetailsAction } from '../actions';
import { usePushSubscription } from 'server';

export const hasNewContexts = (details, update) => {
    if (Object.keys(details).length === 0) {
        return true;
    }
    const { gamingContexts = [] } = details?.gamingContextInfo || {};
    const { leaderboardRules = [] } = update;
    const rulesContextCodes = pipe(
        map(path(['gameRoundRuleInfo', 'gamingContextCodes'])),
        flatten,
        filter(Boolean)
    )(leaderboardRules);

    return difference(
        rulesContextCodes,
        gamingContexts.map(ctx => ctx.code)
    ).length > 0;
};

export const useDetailsUpdate = () => {
    const { state: { details = {} }, dispatch } = useContext(DetailsContext);
    const updateState = update => dispatch(updateDetailsAction(update));
    const [message, setMessage] = useState(null);

    usePushSubscription(71032, () => setMessage);

    useMountEffect((isMounted) => {
        if (!message) {
            return;
        }

        const { data: update } = message;

        if (hasNewContexts(details, update)) {
            const leaderboardId = details.leaderboardId ? details.leaderboardId : update.leaderboardId;
            fetchDetails({ leaderboardId })
                .then(({ data }) => isMounted() && updateState(data.leaderboardDetails))
                .catch(() => isMounted() && updateState(update));
        } else {
            updateState(update);
        }

        setMessage(null);
    }, [message]);
};

export default compose(
    Wrapped => (props) => {
        useSubscriptionOnDetailsUpdate(props);
        useDetailsUpdate(props);

        return <Wrapped {...props} />;
    }
);
